import React from 'react';
import PropTypes from 'prop-types';
import * as S from './styles';
import MuiMultSelect from 'newComponents/MuiMultSelect';
import { useMessage } from 'newComponents/ChatWhatsapp/context/MessageContext';
import { FormControlLabel, InputLabel } from '@material-ui/core';

const FilterModal = ( { onClose, position, modalRef } ) => {
	const { operators, selectedOperators, handleSelectionOperatorsChange, loadChats, resetOficialCursor, departments, selectedDepartments, handleSelectionDepartmentsChange, showOnlyBannedPhones, setShowOnlyBannedPhones } = useMessage();

	const handleSubmitFilter = () => {
		loadChats( true );
		resetOficialCursor();
		onClose();
	};

	return (
		<S.FilterModal ref={modalRef} position={position}>
			<h2>Filtros</h2>
			<MuiMultSelect 
				options={departments} 
				selected={selectedDepartments ?? []} 
				callback={handleSelectionDepartmentsChange} 
				label="Departamento"
			/>
			<MuiMultSelect 
				options={operators} 
				selected={selectedOperators ?? []} 
				callback={handleSelectionOperatorsChange} 
				label="Atendido por"
			/>
			<S.FilterNumberIsActive>
				<InputLabel>Mostrar somente conversas atendidas por telefones desativados</InputLabel>
				<FormControlLabel
					control={
						<S.GreenSwitch
							checked={showOnlyBannedPhones}
							onChange={() => setShowOnlyBannedPhones( !showOnlyBannedPhones )}
							value={showOnlyBannedPhones}
							/>
						}/>
			</S.FilterNumberIsActive>
			<div style={{ display: 'flex', justifyContent: 'space-between' }}>
				<button onClick={onClose} style={{ padding: '10px 20px', background: '#f0f0f0', border: 'none', borderRadius: '4px' }}>Cancelar</button>
				<button onClick={handleSubmitFilter} style={{ padding: '10px 20px', background: '#00A884', color: 'white', border: 'none', borderRadius: '4px' }}>Confirmar</button>
			</div>
		</S.FilterModal>
	);
};

FilterModal.propTypes = {
	onClose  : PropTypes.func.isRequired,
	position : PropTypes.shape( {
		top  : PropTypes.number.isRequired,
		left : PropTypes.number.isRequired
	} ).isRequired,
};

export default FilterModal; 